/**
 * Switching the active customer reloads the whole app, so that no store, cache
 * or open detail page keeps data belonging to the previous company. The "you
 * are now working in X" confirmation therefore cannot be a plain toast — it
 * would be thrown away with the rest of the page. It is parked here instead and
 * drained once on the next boot (see App.vue).
 */
const PENDING_SWITCH_KEY = 'pendingCustomerSwitch'

/** Remember which customer we just switched to, for the post-reload toast. */
export function markCustomerSwitched(customerName: string): void {
  sessionStorage.setItem(PENDING_SWITCH_KEY, customerName)
}

/** Read and clear the pending switch confirmation. Null when there is none. */
export function takeSwitchedCustomer(): string | null {
  const name = sessionStorage.getItem(PENDING_SWITCH_KEY)
  if (name !== null) sessionStorage.removeItem(PENDING_SWITCH_KEY)
  return name
}
